/**
 * 游客临时Token管理工具
 * 用于未登录用户的购物车和订单操作
 */

/**
 * 生成唯一的临时token
 * 格式: guest_时间戳_随机字符串
 */
export function generateGuestToken() {
  const timestamp = Date.now()
  const random = Math.random().toString(36).substring(2, 15)
  const token = `guest_${timestamp}_${random}`
  return token
}

/**
 * 获取或创建游客token
 * 如果本地存储中没有,则创建一个新的
 */
export function getGuestToken() {
  let guestToken = localStorage.getItem('guestToken')
  
  if (!guestToken) {
    guestToken = generateGuestToken()
    localStorage.setItem('guestToken', guestToken)
  }
  
  return guestToken
}

/**
 * 清除游客token
 * 通常在用户登录后调用
 */
export function clearGuestToken() {
  localStorage.removeItem('guestToken')
}

/**
 * 检查是否是游客token
 */
export function isGuestToken(token) {
  return token && token.startsWith('guest_')
}

/**
 * 获取当前有效的token (用户token或游客token)
 */
export function getCurrentToken() {
  const userToken = localStorage.getItem('token')
  
  if (userToken) {
    return userToken
  }
  
  return getGuestToken()
}

/**
 * 检查用户是否已登录
 */
export function isUserLoggedIn() {
  const token = localStorage.getItem('token')
  return token && !isGuestToken(token)
}
